/**
 * @file   src\mobile\pages\ManageInventory.js
 * @brief  This file is responsible for manage inventory section
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState, useEffect, useRef } from "react";
import { Tabs, Tab } from "react-bootstrap";
import MenuBottomBar from "../components/menuBottomMobile";
import BedSmallIcn from "../images/bed-small-icn.svg";
import BathSmallIcn from "../images/bath-small-icn.svg";
import SqftSmallIcn from "../images/sqft-small-icn.svg";
import "../styles/clients.scss";
import "../styles/manage-inventory.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
  checkTutorialDisplayStatus,
  classesBasedOnScroll,
  getLocalStorage,
  getUserId,
  getUserType,
  removeDecimalZeros,
  saveTutorialStatusToLocal,
  setBodyBackgroundGrey,
  setLocalStorage,
  truncate,
} from "../../helpers/common";
import {
  INVENTORY_KEY,
  INVENTORY_LTR,
  INVENTORY_LTR_STR,
  INVENTORY_SELL,
  INVENTORY_SELL_LTR,
  INVENTORY_SELL_STR,
  INVENTORY_STR,
  SCROLL_DIRECTION_DOWN,
  USER_INFO_KEY,
  USER_TYPE_AGENT,
} from "../../constants/common";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserStatistics } from "../../actions/userprofile";
import {
  getInventoryById,
  getMyInventoryList,
} from "../../services/inventoryService";
import { checkInventoryType, checkValidImage } from "../../helpers/inventory";
import noImage from "../../images/no-image-placeholder.png";
import Sortoffcanvas from "../components/Common/Sortoffcanvas";
import { pageURLs } from "../../constants/pageURLs";
import ClientListing from "../components/WantAdListing/ClientListing";
import { getClientDetails } from "../../services/agentClientsService";
import { saveTutorialStatus } from "../../services/commonServices";
import PropertyActionDropdown from "../components/PropertyActionDropdown";
import HandleScroll from "../commonComponents/HandleScroll";

const ManageInventory = (props) => {
  const scrollStates = HandleScroll();
  const isReachedBottom = _.get(scrollStates, "isReachedBottom", null);
  const scrollDirection = _.get(scrollStates, "direction", null);
  useEffect(() => {
    document.body.classList.add("bg-offcanvas-fix");
  }, []);
  const tutorialPage = 8;

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const innerLayoutRef = useRef(null);

  const [showInventorySort, setShowInventorySort] = useState(false);
  const InventorySortClose = () => setShowInventorySort(false);
  const InventorySortShow = () => setShowInventorySort(true);

  const state = location.state;

  const [showDraftTutorial, setShowDraftTutorial] = useState(false);

  const [status, setStatus] = useState(
    state && state.showDraft
      ? "Draft"
      : state && state.showClosed
      ? "Closed"
      : "Published"
  );
  const [currPage, setCurrPage] = useState(1); // storing current page number
  const [prevPage, setPrevPage] = useState(0); // storing prev page number
  const [wasLastList, setWasLastList] = useState(false); // setting a flag to know the last list
  const [showNoResult, setShowNoResult] = useState(true);
  const PAGE_LIMIT = 10;
  const userType = getUserType();
  const isAgent = userType === USER_TYPE_AGENT ? true : false;
  const [isPremiumUser, setIsPremiumUser] = useState(null);

  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails
  );
  const userStatictics = useSelector(
    (state) => state?.userProfile?.userStatictics
  );
  const userPrivileges = useSelector(
    (state) => state?.userProfile?.userPrivileges
  );
  const [userCount, setUserCount] = useState({});
  const [allowedCount, setAllowedCount] = useState({});
  const [userDetails, setUserDetails] = useState(null);
  const [options, setOptions] = useState([
    { value: "createdon", label: "Recently " + status },
    { value: "price", label: "Price" },
  ]);
  const [sortParam, setSortParam] = useState(options[0]);
  const [isSortParamChanged, setIsSortParamChanged] = useState(false);
  const [myInventoryList, setMyInventoryList] = useState([]); // to set the inventory data
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [isClientIdChanged, setIsClientIdChanged] = useState(false);

  useEffect(() => {
    //Need to show inventory onboard very first time
    if (myInventoryList.length > 0 && status == "Draft") {
      let DisplayInventoryAddOnboard = checkTutorialDisplayStatus(tutorialPage); //Inventory onboard display
      if (DisplayInventoryAddOnboard) {
        setShowDraftTutorial(true);
      }
    }
  }, [myInventoryList]);

  useEffect(() => {
    if (userDetailsFromStore !== null && userDetailsFromStore?.length > 0) {
      setUserDetails(userDetailsFromStore[0]);
      if (userDetailsFromStore[0]?.period !== 1 && userType === 2) {
        setIsPremiumUser(true);
      } else {
        setIsPremiumUser(false);
      }
    } else {
      setUserDetails(null);
    }
  }, [userDetailsFromStore]);

  useEffect(() => {
    if (userPrivileges !== null && userPrivileges.length > 0) {
      setAllowedCount(userPrivileges[0]);
    } else {
      setAllowedCount({});
    }
  }, [userPrivileges]);

  useEffect(() => {
    if (userStatictics !== null && userStatictics.length > 0) {
      setUserCount(userStatictics[0]);
    } else {
      setUserCount({});
    }
  }, [userStatictics]);

  useEffect(() => {
    const payload = {
      UserPlanId: userDetails?.User_Plan_Id,
    };

    dispatch(fetchUserStatistics(payload));
  }, [userDetails]);

  useEffect(() => {
    if (isSortParamChanged || isClientIdChanged) {
      setCurrPage(1);
      setPrevPage(0);
      setMyInventoryList([]);
      setWasLastList(false);
      setIsSortParamChanged(false);
      setIsClientIdChanged(false);
    }
    if (currPage == 0) {
      //setMyInventoryList([]);
    }
    if (!wasLastList && prevPage !== currPage) {
      const data = {
        status: status,
        sortBy: sortParam?.value,
        page: currPage,
        limit: PAGE_LIMIT,
      };
      if (selectedClientId) {
        data.clientId = selectedClientId;
        data.isClientInfoReq = false;
        data.type = 2;
        data.sortBy = sortParam?.value;
        getClientInventory(data);
      } else {
        data.userId = getUserId();
        fetchMyInventory(data);
      }
    }
  }, [
    currPage,
    wasLastList,
    status,
    sortParam?.value,
    isClientIdChanged == true,
    isSortParamChanged == true,
  ]);

  const updateAfterDelete = (invId) => {
    if (invId) {
      const currentInvList = myInventoryList;

      const arrayAfterDelete = currentInvList.filter(function (ca) {
        return ca.Inv_Id !== invId;
      });
      setMyInventoryList(arrayAfterDelete);
    }
  };

  useEffect(() => {
    setOptions([
      { value: "createdon", label: "Recently " + status },
      { value: "price", label: "Price" },
    ]);
    setSortParam({ value: "createdon", label: "Recently " + status });
  }, [status]);

  /**
   * To handle fetch inventory data
   * @param {*} query
   */
  const fetchMyInventory = async (query) => {
    await getMyInventoryList(query)
      .then((response) => {
        const responseResult = _.get(response, "result", null);
        if (response.errorCode === 0 && responseResult.length > 0) {
          setMyInventoryList([...myInventoryList, ...responseResult]);
        } else if (responseResult && responseResult.length === 0) {
          setShowNoResult(false);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };
  /**
   * To get client's inventory
   * @param {*} reqPayload
   */
  const getClientInventory = async (reqPayload) => {
    await getClientDetails(reqPayload)
      .then((response) => {
        const responseResult = _.get(response, "result", null);

        if (
          response.errorCode === 0 &&
          responseResult?.inventoryList.length > 0
        ) {
          setMyInventoryList([
            ...myInventoryList,
            ...responseResult?.inventoryList,
          ]);
        } else if (responseResult && responseResult.length === 0) {
          setShowNoResult(false);
        }
      })
      .catch((err) => {
        console.log("Error", err);
      });
  };

  // to list my inventory
  useEffect(() => {
    if (myInventoryList?.length > 0) {
      setPrevPage(currPage);
      setWasLastList(false);
      setShowNoResult(false);
    } else {
      setWasLastList(true);
      setShowNoResult(true);
    }
  }, [myInventoryList]);

  useEffect(() => {
    if (isReachedBottom) {
      setCurrPage((prevState) => prevState + 1);
    }
  }, [isReachedBottom]);

  useEffect(() => {
    setBodyBackgroundGrey();
  }, []);

  const handleSortParam = (selectedParam) => {
    setIsSortParamChanged(true);
    setSortParam(selectedParam);
    setShowInventorySort(false);
  };
  /**
   * To handle edit inventory
   * @param {*} inventoryId
   */
  const onEdit = async (inventoryId) => {
    if (inventoryId) {
      await getInventoryById(inventoryId)
        .then((response) => {
          const responseResult = _.get(response, "result", null);
          if (response.errorCode === 0 && responseResult) {
            if (userCount?.Inventory >= allowedCount?.Inventory) {
              navigate(pageURLs.updatePlan, {
                state: { isFromSettings: true },
              });
            } else {
              navigate(pageURLs.mobileEditInventory, {
                state: {
                  data: responseResult,
                  inventoryId: inventoryId,
                },
              });
            }
          } else {
            console.log("Something went wrong");
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };
  /**
   * To handle navigation to inventory details page
   * @param {*} inventoryId
   */
  const handleInventoryItemClick = (inventoryId) => {
    setLocalStorage(INVENTORY_KEY, {
      inventoryId: inventoryId,
      isFromListingPage: true,
    });
    navigate(pageURLs.mobilememberInventoryDetails);
  };
  /**
   * To handle inventory tile view
   * @returns
   */
  const loadInventory = () => {
    if (showNoResult || myInventoryList !== null) {
      if (myInventoryList?.length > 0) {
        return (
          myInventoryList &&
          myInventoryList?.map((inventory, i) => {
            const invType = checkInventoryType(
              _.get(inventory, "proprtyPurpose", "")
            );
            const bedRoom = removeDecimalZeros(
              _.get(inventory, "Bedrooms", "")
            );
            const bathRoom = removeDecimalZeros(
              _.get(inventory, "Bathrooms", "")
            );
            const sqFt = removeDecimalZeros(_.get(inventory, "Sqft", ""));
            const acreage = removeDecimalZeros(
              _.get(inventory, "TotalAcre", "")
            );
            let lotSizeUnit = _.get(inventory, "Acre_Sqft", "");
            if (lotSizeUnit && lotSizeUnit !== 0) {
              lotSizeUnit = lotSizeUnit === 1 ? " Acres" : " Sqft";
            }
            const isSold = _.get(inventory, "IsSold", "");
            let photos = _.get(inventory, "photos", []);
            if (photos.length == 0) {
              photos = _.get(inventory, "CoverPhotos", []);
            }

            const isDraftItem = _.get(inventory, "IsSavedDraft", "");
            const inventoryId = _.get(inventory, "Inv_Id", "");
            const firstPhoto = checkValidImage({ photos: photos, index: 0 });
            const secondPhoto = checkValidImage({ photos: photos, index: 1 });
            const thirdPhoto = checkValidImage({ photos: photos, index: 2 });
            let titleText = "";
            switch (invType) {
              case INVENTORY_SELL:
                titleText = " selling";
                break;
              case INVENTORY_LTR:
                titleText = " renting";
                break;
              case INVENTORY_STR:
                titleText = " renting";
                break;
              case INVENTORY_LTR_STR:
                titleText = " renting";
                break;
              case INVENTORY_SELL_LTR:
                titleText = " selling, renting";
                break;
              case INVENTORY_SELL_STR:
                titleText = " selling, renting";
                break;
              default:
                titleText = " selling, renting";
                break;
            }
            return (
              <>
                <a
                  href={void 0}
                  role={!isDraftItem ? "button" : ""}
                  className="txt-no-underline"
                  onClick={() =>
                    !isDraftItem
                      ? handleInventoryItemClick(inventoryId)
                      : onEdit(inventoryId)
                  }
                >
                  <div className="property-listing-mob">
                    <div className="inventory-banner-small position-relative">
                      {photos.length === 0 && (
                        <div className="banner-row">
                          <div className="banner-column-full w-100 h-166">
                            <div className="full-col-img-wrap h-100 placeholder-wrap-bg brdr-8">
                              <img
                                className="brdr-8 placeholder-img-style"
                                src={noImage}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {photos.length === 1 && (
                        <div className="banner-row">
                          <div className="banner-column-full w-100 h-166">
                            <div className="full-col-img-wrap h-100">
                              <img
                                className="brdr-8 col-img-style"
                                src={firstPhoto}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {photos.length === 2 && (
                        <div className="banner-row">
                          <div className="inventory-banner-small banner-column-half-small h-166">
                            <div className="half-col-img-wrap h-100">
                              <img
                                className="brdr-top-left-8 brdr-btm-left-8 brdr-t-r-8 no-brdr-b-l-0 col-img-style"
                                src={firstPhoto}
                              />
                            </div>
                          </div>

                          <div className="inventory-banner-small banner-column-half-small h-166">
                            <div className="half-col-img-wrap-right h-100">
                              <img
                                className="brdr-top-right-8 brdr-btm-right-8 no-brdr-t-r-0 brdr-b-r-8 brdr-b-l-8 col-img-style "
                                src={secondPhoto}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {photos.length >= 3 && (
                        <div className="banner-row">
                          <div className="banner-column-half h-166">
                            <div className="half-col-img-wrap h-100">
                              <img
                                className="brdr-top-left-8 brdr-btm-left-8 no-brder-b-l-0 col-img-style"
                                src={firstPhoto}
                              />
                            </div>
                          </div>

                          <div className="banner-column-quarter h-166">
                            <div className="quarter-col-img-wrap-top h-50-percent pt-0">
                              <img
                                className="brdr-top-right-8 brdr-t-r-8  col-img-style"
                                src={secondPhoto}
                              />
                            </div>
                            <div className="quarter-col-img-wrap-btm h-50-percent pb-0">
                              <img
                                className="brdr-btm-right-8 col-img-style "
                                src={thirdPhoto}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="property-info-outer-mob pt-3">
                      <div className="property-top-mob">
                        <div className="property-info-wrap-mob">
                          <div
                            className={
                              isSold
                                ? "want-ad-tag mb-2 ms-0 orange-tag-bg"
                                : "want-ad-tag mb-2 ms-0 grey-tag-bg"
                            }
                          >
                            <span className="tag-icon grey-color-icon">
                              {isSold ? "CLOSED" : "Open To " + titleText}
                            </span>
                          </div>

                          <span
                            className={
                              _.get(inventory, "Intro_Count", "0") > 0
                                ? "want-ad-tag align-middle green-tag-bg"
                                : "want-ad-tag align-middle grey-tag-bg"
                            }
                          >
                            <i className="buy-icon"></i>
                            {_.get(inventory, "Intro_Count", "0")}
                          </span>
                          <h6 className="long-txt-fix">
                            {" "}
                            {truncate(_.get(inventory, "Location", ""), 40)}
                          </h6>
                          <ul className="want-ad-btm-list">
                            {bedRoom && (
                              <li>
                                <span className="list-txt-btm">{bedRoom}</span>
                                <span className="list-icns-btm">
                                  <img src={BedSmallIcn} />
                                </span>
                              </li>
                            )}
                            {bathRoom && (
                              <>
                                <li className="sep-v-line">|</li>
                                <li>
                                  <span className="list-txt-btm">
                                    {bathRoom}
                                  </span>
                                  <span className="list-icns-btm">
                                    <img src={BathSmallIcn} />
                                  </span>
                                </li>
                              </>
                            )}
                            {sqFt && (
                              <>
                                <li className="sep-v-line">|</li>
                                <li>
                                  <span className="list-txt-btm">
                                    {sqFt} sqft
                                  </span>
                                  <span className="list-icns-btm">
                                    <img src={SqftSmallIcn} />
                                  </span>
                                </li>
                              </>
                            )}
                            {acreage && (
                              <>
                                <li className="sep-v-line">|</li>
                                <li>
                                  <span className="list-txt-btm">
                                    {acreage + lotSizeUnit}
                                  </span>
                                  <span className="list-icns-btm">
                                    <img src={SqftSmallIcn} />
                                  </span>
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                        {status === "Draft" && (
                          <div
                            className="social-btns-wrap"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <PropertyActionDropdown
                              onEdit={() => onEdit(inventoryId)}
                              inventoryId={inventoryId}
                              isFromDraft={true}
                              dropDownClass="dropdown-overflow-fix"
                              updateAfterDelete={updateAfterDelete}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </a>
              </>
            );
          })
        );
      } else {
        if (!showNoResult) {
          return (
            <div className="no-result-wrap mw-435">
              <h3>No results found</h3>
            </div>
          );
        }
      }
    }
  };

  const handleChangeClient = (e) => {
    const clientId = e?.value || null;
    setSelectedClientId(clientId);
    setIsClientIdChanged(true);
  };

  const handleTabChange = (tab) => {
    if (tab !== status) {
      setSortParam(options[0]);
      setMyInventoryList([]);
      setCurrPage(1);
      setStatus(tab);
      setPrevPage(0);
      setWasLastList(false);
    }
  };

  const handleTutorialClose = () => {
    saveTutorialStatusToLocal(tutorialPage);
    saveTutorialToDb();
    setShowDraftTutorial(false);
  };

  const saveTutorialToDb = async () => {
    await saveTutorialStatus(tutorialPage, 1); //Save status
  };

  const { mainWrapperClass, contentWrapperClass } =
    classesBasedOnScroll(scrollDirection);
  return (
    <div className={mainWrapperClass + " inventory-wrap"}>
      <div className={contentWrapperClass}>
        <div className="inner-layout-header-new bg-white">
          <div className="top-three-comp-header w-100 top-three-comp-headerborder">
            <div className="top-three-comp-header-inner w-100">
              <a
                className="back-link-btn"
                href={void 0}
                onClick={() => navigate(pageURLs.proDashboard)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z"
                    fill="#1B1C1E"
                  />
                </svg>
              </a>
              <div className="heading">My Inventory</div>
              <div className="right-mobbtn-wrap">
                <a className="action-btn" href="#" onClick={InventorySortShow}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 10C10 10.1658 9.93415 10.3247 9.81694 10.4419C9.69973 10.5592 9.54076 10.625 9.375 10.625H3.75C3.58424 10.625 3.42527 10.5592 3.30806 10.4419C3.19085 10.3247 3.125 10.1658 3.125 10C3.125 9.83424 3.19085 9.67527 3.30806 9.55806C3.42527 9.44085 3.58424 9.375 3.75 9.375H9.375C9.54076 9.375 9.69973 9.44085 9.81694 9.55806C9.93415 9.67527 10 9.83424 10 10ZM3.75 5.625H14.375C14.5408 5.625 14.6997 5.55915 14.8169 5.44194C14.9342 5.32473 15 5.16576 15 5C15 4.83424 14.9342 4.67527 14.8169 4.55806C14.6997 4.44085 14.5408 4.375 14.375 4.375H3.75C3.58424 4.375 3.42527 4.44085 3.30806 4.55806C3.19085 4.67527 3.125 4.83424 3.125 5C3.125 5.16576 3.19085 5.32473 3.30806 5.44194C3.42527 5.55915 3.58424 5.625 3.75 5.625ZM8.125 14.375H3.75C3.58424 14.375 3.42527 14.4408 3.30806 14.5581C3.19085 14.6753 3.125 14.8342 3.125 15C3.125 15.1658 3.19085 15.3247 3.30806 15.4419C3.42527 15.5592 3.58424 15.625 3.75 15.625H8.125C8.29076 15.625 8.44973 15.5592 8.56694 15.4419C8.68415 15.3247 8.75 15.1658 8.75 15C8.75 14.8342 8.68415 14.6753 8.56694 14.5581C8.44973 14.4408 8.29076 14.375 8.125 14.375ZM17.9422 12.6828C17.8841 12.6247 17.8152 12.5786 17.7393 12.5472C17.6635 12.5157 17.5821 12.4995 17.5 12.4995C17.4179 12.4995 17.3365 12.5157 17.2607 12.5472C17.1848 12.5786 17.1159 12.6247 17.0578 12.6828L15 14.7414V8.75C15 8.58424 14.9342 8.42527 14.8169 8.30806C14.6997 8.19085 14.5408 8.125 14.375 8.125C14.2092 8.125 14.0503 8.19085 13.9331 8.30806C13.8158 8.42527 13.75 8.58424 13.75 8.75V14.7414L11.6922 12.6828C11.5749 12.5655 11.4159 12.4997 11.25 12.4997C11.0841 12.4997 10.9251 12.5655 10.8078 12.6828C10.6905 12.8001 10.6247 12.9591 10.6247 13.125C10.6247 13.2909 10.6905 13.4499 10.8078 13.5672L13.9328 16.6922C13.9909 16.7503 14.0598 16.7964 14.1357 16.8279C14.2115 16.8593 14.2929 16.8755 14.375 16.8755C14.4571 16.8755 14.5385 16.8593 14.6143 16.8279C14.6902 16.7964 14.7591 16.7503 14.8172 16.6922L17.9422 13.5672C18.0003 13.5091 18.0464 13.4402 18.0779 13.3643C18.1093 13.2885 18.1255 13.2071 18.1255 13.125C18.1255 13.0429 18.1093 12.9615 18.0779 12.8857C18.0464 12.8098 18.0003 12.7409 17.9422 12.6828Z"
                      fill="#1B1C1E"
                    />
                  </svg>
                </a>
                <Sortoffcanvas
                  show={showInventorySort}
                  onHide={InventorySortClose}
                  sortParam={sortParam}
                  handleSortParam={handleSortParam}
                  options={options}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="inner-layout-content-new">
          <div className="tab-wrap tab-wrap-fix pb-45">
            {userType === USER_TYPE_AGENT && isPremiumUser && (
              <div className="search_wrap_mobile_top input-group">
                <ClientListing
                  handleChangeClient={handleChangeClient}
                  clientId={selectedClientId}
                />
              </div>
            )}
            <div className="tab-scroll-hide"></div>
            <Tabs
              id="controlled-tab-example"
              unmountOnExit
              activeKey={status}
              onSelect={(k) => {
                handleTabChange(k);
              }}
            >
              <Tab eventKey="Published" title="Stored">
                {userCount?.Inventory >= allowedCount?.Inventory && (
                  <div className="gitca-upgrade-premium d-flex align-items-center justify-space-between flex-column">
                    <p className="m-0">
                      Want unlimited properties in your inventory?
                    </p>
                    <div className="d-flex align-items-center justify-center">
                      <h4>
                        Upgrade to <span>Gitcha</span> Premium
                      </h4>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M16.3853 11.2693C16.3869 11.5241 16.3095 11.7732 16.1637 11.9822C16.0179 12.1912 15.8109 12.35 15.5713 12.4365L11.5361 13.9209L10.0517 17.9529C9.96382 18.1917 9.80478 18.3978 9.59607 18.5434C9.38735 18.689 9.13901 18.767 8.88454 18.767C8.63007 18.767 8.38172 18.689 8.173 18.5434C7.96429 18.3978 7.80525 18.1917 7.71735 17.9529L6.22907 13.9256L2.19625 12.4412C1.95745 12.3533 1.75135 12.1943 1.60577 11.9855C1.4602 11.7768 1.38214 11.5285 1.38214 11.274C1.38214 11.0195 1.4602 10.7712 1.60577 10.5625C1.75135 10.3538 1.95745 10.1947 2.19625 10.1068L6.23141 8.62244L7.71579 4.59041C7.80369 4.35161 7.96273 4.14551 8.17144 3.99993C8.38016 3.85435 8.6285 3.7763 8.88297 3.7763C9.13744 3.7763 9.38579 3.85435 9.5945 3.99993C9.80322 4.14551 9.96226 4.35161 10.0502 4.59041L11.5345 8.62557L15.5666 10.1099C15.8059 10.1953 16.013 10.3525 16.1595 10.56C16.3061 10.7675 16.3849 11.0153 16.3853 11.2693ZM12.0103 3.76932H13.2603V5.01932C13.2603 5.18508 13.3262 5.34405 13.4434 5.46126C13.5606 5.57847 13.7196 5.64432 13.8853 5.64432C14.0511 5.64432 14.21 5.57847 14.3273 5.46126C14.4445 5.34405 14.5103 5.18508 14.5103 5.01932V3.76932H15.7603C15.9261 3.76932 16.085 3.70347 16.2023 3.58626C16.3195 3.46905 16.3853 3.31008 16.3853 3.14432C16.3853 2.97856 16.3195 2.81959 16.2023 2.70238C16.085 2.58517 15.9261 2.51932 15.7603 2.51932H14.5103V1.26932C14.5103 1.10356 14.4445 0.944586 14.3273 0.827376C14.21 0.710166 14.0511 0.644318 13.8853 0.644318C13.7196 0.644318 13.5606 0.710166 13.4434 0.827376C13.3262 0.944586 13.2603 1.10356 13.2603 1.26932V2.51932H12.0103C11.8446 2.51932 11.6856 2.58517 11.5684 2.70238C11.4512 2.81959 11.3853 2.97856 11.3853 3.14432C11.3853 3.31008 11.4512 3.46905 11.5684 3.58626C11.6856 3.70347 11.8446 3.76932 12.0103 3.76932ZM18.8853 6.26932H18.2603V5.64432C18.2603 5.47856 18.1945 5.31959 18.0773 5.20238C17.96 5.08517 17.8011 5.01932 17.6353 5.01932C17.4696 5.01932 17.3106 5.08517 17.1934 5.20238C17.0762 5.31959 17.0103 5.47856 17.0103 5.64432V6.26932H16.3853C16.2196 6.26932 16.0606 6.33517 15.9434 6.45238C15.8262 6.56959 15.7603 6.72856 15.7603 6.89432C15.7603 7.06008 15.8262 7.21905 15.9434 7.33626C16.0606 7.45347 16.2196 7.51932 16.3853 7.51932H17.0103V8.14432C17.0103 8.31008 17.0762 8.46905 17.1934 8.58626C17.3106 8.70347 17.4696 8.76932 17.6353 8.76932C17.8011 8.76932 17.96 8.70347 18.0773 8.58626C18.1945 8.46905 18.2603 8.31008 18.2603 8.14432V7.51932H18.8853C19.0511 7.51932 19.21 7.45347 19.3273 7.33626C19.4445 7.21905 19.5103 7.06008 19.5103 6.89432C19.5103 6.72856 19.4445 6.56959 19.3273 6.45238C19.21 6.33517 19.0511 6.26932 18.8853 6.26932Z"
                          fill="#66B927"
                        />
                      </svg>
                    </div>
                  </div>
                )}
                <div>{loadInventory()}</div>
              </Tab>
              <Tab eventKey="Closed" title="Closed">
                {loadInventory()}
              </Tab>

              <Tab eventKey="Draft" title="Drafts">
                {showDraftTutorial && (
                  <div className="draft-tutorial-info position-relative mb-3">
                    <button
                      className="btn strengthen-ad-closebtn"
                      onClick={() => handleTutorialClose()}
                    >
                      close
                    </button>
                    <span>Your property has been saved to your drafts.</span>{" "}
                    When you’re ready to continue{" "}
                    {isAgent ? "editing" : "building"} it, you can find it here,
                    under the {isPremiumUser ? "Pro Dashboard" : "My Portfolio"}{" "}
                    tab.
                  </div>
                )}
                {loadInventory()}
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>

      {scrollDirection !== SCROLL_DIRECTION_DOWN && (
        <div className="inner-layout-footer-new inner-layout-footer-topfix">
          <div className="bottomMenu bottom-menu-index">
            <MenuBottomBar scrollDirection={scrollDirection} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageInventory;
